import styled from 'particles/themes/styled'
import { Size } from '..'

interface TextInputContainerProp {
    width?: number | string
    hasError?: boolean
    size: Size
    minWidth?: string
}

export const sizeMap: Record<Size, { minHeight: string; paddingY: string; paddingX: string }> = {
    m: {
        minHeight: '40px',
        paddingY: '7px',
        paddingX: '11px',
    },
    s: {
        minHeight: '32px',
        paddingY: '0px',
        paddingX: '7px',
    },
}

export const TextInputContainer = styled.div<TextInputContainerProp>`
    width: ${({ width }): string => (width ? (typeof width === 'string' ? width : width + 'px') : '100%')};
    min-width: ${({ minWidth }) => minWidth || '198px'};
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[200]};
    .textfield-input-container {
        width: 100%;
        display: flex;
        background-color: ${({ theme }) => theme.colors.surface.primary};
        height: ${({ size }): string => `${sizeMap[size].minHeight}`};
        min-height: ${({ size }): string => `${sizeMap[size].minHeight}`};
        border: 1px solid
            ${({ theme, hasError }): string => (hasError ? theme.colors.border.error : theme.colors.border.primary)};
        padding: ${({ size }) => `${sizeMap[size].paddingY} ${sizeMap[size].paddingX}`};
        box-sizing: border-box;
        border-radius: 4px;
        gap: ${({ theme }) => theme.spacing[100]};
        &.disabled {
            color: ${({ theme }) => theme.colors.text.disable};
            background-color: ${({ theme }) => theme.colors.surface.disablePastel};
        }
        &:focus-within {
            border: 1px solid ${({ theme }) => theme.colors.border.neutralActionActive};
        }
        input {
            font-family: inherit;
            font-size: ${({ theme }) => theme.textScale.bodyS400};
            width: 100%;
            border: none;
            resize: none;
            padding: 0;
            outline: none;
            ${({ theme }) => theme.textScale.bodyS400};
            color: ${({ theme }) => theme.colors.text.primary};
            background-color: transparent;
            &:disabled {
                color: ${({ theme }) => theme.colors.text.disable};
            }
            &::placeholder {
                color: ${({ theme }) => theme.colors.text.placeholder};
                opacity: 1;
            }
        }
    }
    .input-count-container {
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing[100]};
    }
    .counter-and-error {
        width: 100%;
        max-width: 100%;
        display: flex;
        gap: ${({ theme }) => theme.spacing[200]};
        justify-content: space-between;
        .error {
            width: 100%;
            min-width: 1px;
            word-break: break-word;
        }
    }
    .icon-container {
        display: flex;
        align-items: center;
    }
    .input-icon {
        flex-shrink: 0;
    }
`

interface ReadOnlyContainerProps {
    width?: string | number
    size: Size
}

export const StyledReadOnlyContainer = styled.div<ReadOnlyContainerProps>`
    width: ${({ width }): string => (width ? (typeof width === 'string' ? width : width + 'px') : '224px')};
    min-height: ${({ size }): string => (size === 's' ? '32px' : '40px')};
    padding: ${({ size }) => `${sizeMap[size].paddingY} ${sizeMap[size].paddingX}`};
    display: flex;
    align-items: center;
    border-radius: 4px;
    box-sizing: border-box;
    border: none;
    border-left: 1px solid ${({ theme }) => theme.colors.border.primary};
    color: ${({ theme }) => theme.colors.text.primary};
    outline: none;
    font-family: inherit;
    gap: ${({ theme }) => theme.spacing[100]};
`
